// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcAccInstAccRepIar {
constructor({
        id = null,
        iarCodeAdr = '',
        iarIdIat = '',
        iarEquipmentName = '',
        iarCodeBda = '',
        iarCodeLoc = '',
        iarAccStandAtt = '',
        iarAccResAtt = '',
        iarKeyParamTargetAtt = '',
        iarDescription = '',
        iarKeyParamActualAtt = '',
        iarKeyParamPerfIsReach = '',
        iarAccStandAttList = '',
        iarAccResAttList = '',
        iarKeyParamTargetAttList = '',
        iarKeyParamActualAttList = ''}
= {}) {
    this.id = id;
    this.iarCodeAdr = iarCodeAdr;
    this.iarIdIat = iarIdIat;
    this.iarEquipmentName = iarEquipmentName;
    this.iarCodeBda = iarCodeBda;
    this.iarCodeLoc = iarCodeLoc;
    this.iarAccStandAtt = iarAccStandAtt;
    this.iarAccResAtt = iarAccResAtt;
    this.iarKeyParamTargetAtt = iarKeyParamTargetAtt;
    this.iarDescription = iarDescription;
    this.iarKeyParamActualAtt = iarKeyParamActualAtt;
    this.iarKeyParamPerfIsReach = iarKeyParamPerfIsReach;
    this.iarAccStandAttList = iarAccStandAttList;
    this.iarAccResAttList = iarAccResAttList;
    this.iarKeyParamTargetAttList = iarKeyParamTargetAttList;
    this.iarKeyParamActualAttList = iarKeyParamActualAttList;
}
}

function newEntity() {
return new EmLcAccInstAccRepIar();
}

function gridFields() {
return Object.freeze([
        {
        key: 'status',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarCodeAdr',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarCodeAdr',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarEquipmentName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarEquipmentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarCodeBda',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarCodeLoc',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarCodeLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarAccStandAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarAccStandAttList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'iarAccResAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarAccResAttList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'iarKeyParamTargetAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarKeyParamTargetAttList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'iarInitiatorLoginName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarInitiatorLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iarDescription',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'iarKeyParamActualAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarKeyParamActualAttList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'iarKeyParamPerfIsReach',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.iarKeyParamPerfIsReach',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    statusFilter : "",
    workOrderCodeFilter : "",
    iarCodeAdrFilter : "",
    iarIdIatFilter : "",
    iarEquipmentNameFilter : "",
    iarCodeBdaFilter : "",
    iarCodeLocFilter : "",
    iarInitiatorFilter : "",
    iarInitiatorLoginNameFilter : "",
    iarKeyParamPerfIsReachFilter : "",
    workflowQueryTypeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmLcAccInstAccRepIar',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iarCodeAdrFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarCodeAdr',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iarIdIatFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarIdIat',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'iarEquipmentNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarEquipmentName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iarCodeBdaFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarCodeBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'iarInitiatorLoginNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarInitiatorLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"iarInitiator":"id"}'
                }
        },
        {
        key: 'iarKeyParamPerfIsReachFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.iarKeyParamPerfIsReach',
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'iarCodeAdr',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarCodeAdr',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'iarIdIat',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarIdIat',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'iarEquipmentName',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarEquipmentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'iarCodeBda',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'iarCodeLoc',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'iarDescription',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'iarKeyParamPerfIsReach',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarKeyParamPerfIsReach',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
            ,required: true
                }
        },
        {
        key: 'iarAccStandAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarAccStandAtt',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'iarAccStandAtt'
                }
        },
        {
        key: 'iarAccResAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarAccResAtt',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'iarAccResAtt'
                }
        },
        {
        key: 'iarKeyParamTargetAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarKeyParamTargetAtt',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'iarKeyParamTargetAtt'
                }
        },
        {
        key: 'iarKeyParamActualAttList',
        label: 'label.em.lifecycle.emLcAccInstAccRepIar.entity.iarKeyParamActualAtt',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'iarKeyParamActualAtt'
                }
        }
]

export {EmLcAccInstAccRepIar, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
